import { render, staticRenderFns } from "./Cryptocurrency.vue?vue&type=template&id=72eb2028&scoped=true&"
import script from "./Cryptocurrency.vue?vue&type=script&lang=js&"
export * from "./Cryptocurrency.vue?vue&type=script&lang=js&"
import style0 from "./Cryptocurrency.vue?vue&type=style&index=0&id=72eb2028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eb2028",
  null
  
)

export default component.exports